// Abas das telas PERSONALIZADAS (/personalizados/:slug): logica pura, sem React.
// Cada aba e { slug, uso, montada }:
//   - uso     contador crescente; a de menor uso e a que sai quando passa de MAX_ABAS
//   - montada a tela so e montada depois de ativada (aba restaurada do F5 nao dispara as consultas dela de uma vez)
export const MAX_ABAS = 8;

const chave = (userId) => `central.abas-personalizadas.v1.${userId}`;

// '/personalizados/lojas-ativas' -> 'lojas-ativas'; qualquer outra rota -> null
export function slugDaRota(pathname) {
    const m = /^\/personalizados\/([^/?#]+)\/?$/.exec(String(pathname || ''));
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (_) { return m[1]; }
}

// Abre (ou reativa) a aba do slug. Passou do limite: descarta a menos usada que nao seja a que acabou de abrir.
export function abrirAba(abas, slug, max = MAX_ABAS) {
    const uso = abas.reduce((m, a) => Math.max(m, a.uso), 0) + 1;
    let novas = abas.some(a => a.slug === slug)
        ? abas.map(a => (a.slug === slug ? { ...a, uso, montada: true } : a))
        : [...abas, { slug, uso, montada: true }];
    while (novas.length > max) {
        const velha = novas.filter(a => a.slug !== slug).reduce((m, a) => (a.uso < m.uso ? a : m));
        novas = novas.filter(a => a.slug !== velha.slug);
    }
    return novas;
}

// Fecha a aba. `proxima` = slug que deve ficar ativo depois (a vizinha da direita, senao da esquerda; null = nao sobrou nenhuma).
export function fecharAba(abas, slug, ativa) {
    const i = abas.findIndex(a => a.slug === slug);
    if (i < 0) return { abas, proxima: ativa || null };
    const novas = abas.filter(a => a.slug !== slug);
    if (slug !== ativa) return { abas: novas, proxima: ativa || null };
    const vizinha = novas[i] || novas[i - 1] || null;
    return { abas: novas, proxima: vizinha ? vizinha.slug : null };
}

// Guarda so os slugs, na ordem, em sessionStorage (vale ate fechar a aba do navegador). Tudo em try/catch:
// navegacao privativa ou storage bloqueado nao pode derrubar a tela.
export function gravarAbas(userId, abas) {
    try { window.sessionStorage.setItem(chave(userId), JSON.stringify(abas.map(a => a.slug))); } catch (_) { /* sem storage: so nao restaura */ }
}

export function lerAbas(userId, valida) {
    try {
        const bruto = JSON.parse(window.sessionStorage.getItem(chave(userId)) || '[]');
        if (!Array.isArray(bruto)) return [];
        const abas = [];
        for (const slug of bruto) {
            if (typeof slug !== 'string' || abas.some(a => a.slug === slug)) continue;
            if (valida && !valida(slug)) continue;   // tela que saiu do registry nao volta como aba fantasma
            abas.push({ slug, uso: abas.length + 1, montada: false });
            if (abas.length >= MAX_ABAS) break;
        }
        return abas;
    } catch (_) {
        return [];
    }
}
